import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  CircularProgress,
  Box,
  Alert,
} from '@mui/material';

import GdMasterEntitySelect from '../registration/GdMasterEntitySelect';
import { DefaultOutlinedButton } from '../../utils/Buttons';

// Pop-up di scelta tessere nel rinnovo (R20, sprint 019). Le opzioni disponibili
// (solo GD / GD + PD) sono calcolate dal chiamante in base alle campagne attive per
// tipo e all'eleggibilità età. onChoose riceve 'GD' oppure 'PD_GD'.
// Se l'utente non ha ancora un'entità master GD sul profilo (needGdEntity), il dialog
// mostra il selettore: la scelta è richiesta prima di procedere con un'opzione GD.
export default function RenewCardChoiceDialog({
  open,
  onClose,
  options,
  onChoose,
  loading,
  needGdEntity,
  gdEntityValue,
  gdEntityOptions,
  onGdEntityChange,
  gdFree,
}) {
  const opts = options || { gdOnly: false, gdPlusPd: false };
  const gdBlocked = needGdEntity && !gdEntityValue;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Scegli il tesseramento da rinnovare</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Stack spacing={2} sx={{ pt: 1 }}>
            {needGdEntity && (opts.gdOnly || opts.gdPlusPd) && (
              <Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Seleziona l&apos;entità master GD per procedere con il tesseramento GD.
                </Typography>
                <GdMasterEntitySelect
                  value={gdEntityValue}
                  onChange={onGdEntityChange}
                  options={gdEntityOptions}
                  disabled={(gdEntityOptions || []).length === 0}
                />
                {(gdEntityOptions || []).length === 0 && (
                  <Alert severity="error" sx={{ mt: 1 }}>
                    Nessuna entità disponibile per la registrazione ai Giovani Democratici
                  </Alert>
                )}
              </Box>
            )}

            {opts.pd && (
              <Card variant="outlined">
                <CardActionArea onClick={() => onChoose('PD')}>
                  <CardContent>
                    <Typography variant="h6">Tesseramento PD</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Tessera del Partito Democratico.
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            )}
            {opts.gdOnly && (
              <Card variant="outlined">
                <CardActionArea disabled={gdBlocked} onClick={() => onChoose('GD')}>
                  <CardContent>
                    <Typography variant="h6">Tesseramento GD</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {gdFree
                        ? 'Tesseramento ai Giovani Democratici gratuito (sei già tesserato PD per l’anno corrente).'
                        : 'Tesseramento ai Giovani Democratici (quota GD).'}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            )}
            {opts.gdPlusPd && (
              <Card variant="outlined">
                <CardActionArea disabled={gdBlocked} onClick={() => onChoose('PD_GD')}>
                  <CardContent>
                    <Typography variant="h6">Tesseramento PD e GD</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Tessera PD con tessera GD collegata (si paga la quota PD).
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            )}
            {!opts.pd && !opts.gdOnly && !opts.gdPlusPd && (
              <Typography color="text.secondary">Nessun rinnovo disponibile al momento.</Typography>
            )}
            {gdBlocked && (opts.gdOnly || opts.gdPlusPd) && (gdEntityOptions || []).length > 0 && (
              <Alert severity="info">Seleziona un&apos;entità master GD per abilitare le opzioni.</Alert>
            )}
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <DefaultOutlinedButton onClick={onClose}>Annulla</DefaultOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

RenewCardChoiceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.object,
  onChoose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  needGdEntity: PropTypes.bool,
  gdEntityValue: PropTypes.object,
  gdEntityOptions: PropTypes.array,
  onGdEntityChange: PropTypes.func,
  gdFree: PropTypes.bool,
};
